import { SeverityLevel } from '@microsoft/applicationinsights-web';
import { v4 as uuidv4 } from 'uuid';
import dayjs from 'dayjs';
import { appInsights } from '../services/ApplicationInsightsService';
import { types } from '../actions/timesheet';

const initialState = {
  pending: false,
  commentPending: false,
  error: '',
  data: null,
  tandecounts: null,
  contractortandecounts: null,
  approverRequest: null,
  notifications: [
    { type: 'contractor', data: null },
    { type: 'approver', data: null }
  ],
  validatePending: true,
  validate: {
    timesheet: false,
    expense: false
  }
};

export default function reduce(state = initialState, action) {
  switch (action.type) {
    case types.GET_PARTICULAR_TIMESHEET_PENDING:
      return { ...state, data: null, pending: true, error: '' };
    case types.GET_PARTICULAR_TIMESHEET_REJECTED:
      appInsights.trackException({
        error: new Error(action.payload.message),
        severityLevel: SeverityLevel.Error
      });
      return { ...state, pending: false, error: action.payload.message };
    case types.GET_PARTICULAR_TIMESHEET_FULFILLED:
      return { ...state, pending: false, error: '', data: action.payload };
    case types.UPDATE_GENERAL_DATA:
      return {
        ...state,
        pending: false,
        error: '',
        data: {
          ...state.data,
          [action.payload.Data.prop]: action.payload.Data.value
        }
      };
    case types.UPDATE_TIMESHEET:
      return {
        ...state,
        pending: false,
        error: '',
        data: {
          ...state.data,
          TimesheetDetails: state.data.TimesheetDetails.map((timesheet) =>
            timesheet.Id === action.payload.Data.Id ? action.payload.Data : timesheet
          )
        }
      };
    case types.DELETE_TIMESHEET_LINE:
      return {
        ...state,
        pending: false,
        error: '',
        data: {
          ...state.data,
          TimesheetDetails: state.data.TimesheetDetails.filter((timesheet) => timesheet.Id !== action.payload.id)
        }
      };
    case types.RESTORE_DELETED_TIMESHEET_LINE:
      return {
        ...state,
        pending: false,
        error: '',
        data: {
          ...state.data,
          TimesheetDetails: [...state.data.TimesheetDetails, action.payload.line]
        }
      };
    case types.CHECK_UNCHECK:
      return { ...state, pending: false, error: '', data: { ...state.data, sheetRows: action.payload } };
    case types.CREATE_NEW_TIMESHEET:
      return {
        ...state,
        pending: false,
        error: '',
        data: {
          ...state.data,
          TimesheetDetails: [
            ...state.data.TimesheetDetails,
            {
              Id: uuidv4(10),
              Comment: '',
              Location: '',
              WorkType: { Id: 1, Name: 'Straight Time' },
              TimesheetHoursByDates: state.data.TimesheetDetails[0].TimesheetHoursByDates.map((item) => ({
                Day: item.Day,
                TotalHrs: 0
              }))
            }
          ]
        }
      };
    case types.GET_PENDING_TANDE_COUNTS_FULFILLED:
      return { ...state, pending: false, error: '', tandecounts: action.payload };

    case types.GET_TANDE_COUNTS_CONTRACTOR_FULFILLED:
      return { ...state, pending: false, error: '', contractortandecounts: action.payload };

    case types.GET_TIMESHEET_APPROVER_REQUEST_PENDING:
      return {
        ...state,
        pending: true,
        error: ''
      };
    case types.GET_TIMESHEET_APPROVER_REQUEST_FULFILLED:
      return {
        ...state,
        pending: false,
        error: '',
        notifications: state?.notifications?.map((notification) =>
          notification.type === action.payload.notificationType
            ? { ...notification, data: action.payload.data }
            : notification
        )
      };
    case types.GET_TIMESHEET_APPROVER_REQUEST_REJECTED:
      return {
        ...state,
        pending: false,
        error: action.payload
      };
    case types.CLEAR_TIMESHEET_DATA:
      return initialState;
    case types.CHANGE_STATUS:
      return { ...state, data: { ...state.data, Status: { ...state.data.Status, Status: action.payload } } };
    case types.CHANGE_PERDIEM:
      return {
        ...state,
        data: {
          ...state.data,
          TimesheetPerDiem: state.data.TimesheetPerDiem.map((currentPerDiem) => {
            return dayjs(currentPerDiem.Date).isSame(dayjs(action.payload.Date)) ? action.payload : currentPerDiem;
          })
        }
      };
    case types.CHANGE_PART_OF_PERDIEM:
      return {
        ...state,
        data: {
          ...state.data,
          TimesheetPerDiem: state.data.TimesheetPerDiem.map((currentPerDiem) => {
            const matchedItem = action.payload.find((newItem) => dayjs(currentPerDiem.Date).isSame(newItem.Date));
            return matchedItem ? { ...matchedItem, Date: matchedItem.Date.format('YYYY-MM-DD') } : currentPerDiem;
          })
        }
      };
    case types.GET_TIMESHEET_VALIDATION_FULFILLED:
      return {
        ...state,
        validatePending: false,
        validate: {
          timesheet: action.payload.timesheet,
          expense: action.payload.expense
        }
      };
    case types.GET_TIMESHEET_VALIDATION_PENDING:
      return {
        ...state,
        validatePending: true,
        validate: {
          timesheet: false,
          expense: false
        }
      };
    case types.GET_TIMESHEET_VALIDATION_REJECTED:
      return {
        ...state,
        validatePending: false,
        validate: {
          timesheet: true,
          expense: true
        }
      };
    case types.SAVE_COMMENT_PENDING:
      return {
        ...state,
        commentPending: true
      };
    case types.SAVE_COMMENT_REJECTED:
      return {
        ...state,
        commentPending: false
      };
    case types.SAVE_COMMENT_FULFILLED:
      return {
        ...state,
        commentPending: false,
        data: {
          ...state.data,
          TimesheetRejectionReasons: [
            ...state.data.TimesheetRejectionReasons,
            {
              ActionTaken: 'Pending',
              Id: action.payload.Id,
              Reason: action.payload.Reason,
              CreatedDate: dayjs().toString(),
              User: {
                FirstName: localStorage.getItem('AirswiftFirstName'),
                LastName: localStorage.getItem('AirswiftLastName')
              }
            }
          ]
        }
      };
    case types.UPDATE_COMMENT_PENDING:
      return {
        ...state,
        commentPending: true
      };
    case types.UPDATE_COMMENT_REJECTED:
      return {
        ...state,
        commentPending: false
      };
    case types.UPDATE_COMMENT_FULFILLED:
      return {
        ...state,
        commentPending: false,
        data: {
          ...state.data,
          TimesheetRejectionReasons: state.data.TimesheetRejectionReasons.map((comment) =>
            comment.Id === action.payload.commentId
              ? { ...comment, Reason: action.payload.comment, CreatedDate: dayjs().toString() }
              : comment
          )
        }
      };
    default:
      return state;
  }
}
